import { CircularProgress } from '@mui/material';
import React from 'react';

import * as Styled from './life-area-form-loading.style';

export const LifeAreaFormLoading: React.FC = () => (
  <Styled.Container>
    <CircularProgress />
  </Styled.Container>
);
